var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Oops! Página não encontrada.")]),_c('a',{staticClass:"button",attrs:{"href":"#"},on:{"click":_vm.goToHome}},[_c('i',{staticClass:"icon-home"}),_vm._v(" Voltar na página inicial")])])}
var staticRenderFns = []

export { render, staticRenderFns }